module.exports = __webpack_public_path__ + "static/juice-meta-card-225dd00a391415ce3cbdc84545030d9b.jpg";